import { BooleanInput, SelectInput, useRedirect } from "react-admin";
import { useWatch, useFormContext } from 'react-hook-form';
import React from "react";
import { requiredValidation, followUpDataRangeValidation } from "../../utils/util";
import { CommonInputForCreateReportGrid } from "../common/TemplateInputsForCreateReportGrid";
import { createFollowUpDataRangeChoices, getDefaultValueForFollowUpDataRange, showFollowUpDataRangeInput, showPayslipVerificationInput } from "../../utils/CreateReportUtils";
import { allowCreationOfFollowUpReport, extractQueryParamsFromURL } from "../../mappers/Report";
import { useLocation } from "react-router";
import Button from '@mui/material/Button';
import isEmpty from "lodash/isEmpty"
import { linkButton, width } from '../Styles'

const followUpDataRangeRequiredValidations = [requiredValidation, followUpDataRangeValidation]

const IncomeDynamicFields = (props) => {
  const values = useWatch();
  const { payslipVerificationField, followUpDataRangeField } = props;
  const form = useFormContext();
  const location = useLocation();

  if (followUpDataRangeField) {  //Hide this input only when it's not required and don't have defaultValue
    if (!(followUpDataRangeField.isHidden && (!followUpDataRangeField.required && isEmpty(followUpDataRangeField.defaultValue)))) {
      followUpDataRangeField.isHidden = false;
    }
  }

  const followUpDataRangeChoices = createFollowUpDataRangeChoices(followUpDataRangeField?.possibleValues);
  const followUpDataRangeDefaultValue = getDefaultValueForFollowUpDataRange(followUpDataRangeField, followUpDataRangeChoices);

  const followUpDataRangeFromUrl = extractQueryParamsFromURL(location?.search, 'followUpDataRange');
  const isFollowUpUrlAllowed = followUpDataRangeFromUrl && followUpDataRangeChoices.some(c => c.id === followUpDataRangeFromUrl);
  const resolvedFollowUpDataRangeDefault = isFollowUpUrlAllowed ? followUpDataRangeFromUrl : followUpDataRangeDefaultValue;

  const payslipVerificationFromUrl = extractQueryParamsFromURL(location?.search, 'payslipVerification');
  const resolvedPayslipVerificationDefault = !isEmpty(payslipVerificationFromUrl)
    ? payslipVerificationFromUrl === 'true'
    : payslipVerificationField?.defaultValue;

  React.useEffect(() => {//crs-hook
    if (showFollowUpDataRangeInput(values.reportType, values.multiReportType)) {
      form.setValue("followUpDataRange", resolvedFollowUpDataRangeDefault);
    } else {
      form.setValue("followUpDataRange", undefined);
    }

    if (showPayslipVerificationInput(values.reportType, values.multiReportType)) {
      form.setValue("payslipVerification", resolvedPayslipVerificationDefault);
    } else {
      form.setValue("payslipVerification", false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.reportType, JSON.stringify(values.multiReportType), props.selectedTemplateId, followUpDataRangeField?.defaultValue, payslipVerificationField?.defaultValue]);

  return (
    <>
      {showFollowUpDataRangeInput(values.reportType, values.multiReportType) &&
        <CommonInputForCreateReportGrid
          field={followUpDataRangeField}
          defaultDisplayName="Follow Up Data Range"
          input={
            <SelectInput
              id="reports-create-follow-up-data-range-select"
              source="followUpDataRange"
              name="followUpDataRange"
              variant="outlined"
              size="small"
              label={followUpDataRangeField ? followUpDataRangeField?.placeholder : "Up to 2 years can be selected, data range as an option"}
              choices={followUpDataRangeChoices}
              defaultValue={resolvedFollowUpDataRangeDefault}
              validate={followUpDataRangeField?.required ? followUpDataRangeRequiredValidations : followUpDataRangeValidation}
              allowEmpty={!followUpDataRangeField?.required}
              sx={{ ...width.fluid.w100, marginBottom: "-15px" }}
            />
          }
        />
      }
      {
        showPayslipVerificationInput(values.reportType, values.multiReportType) &&
        <CommonInputForCreateReportGrid
          field={payslipVerificationField}
          defaultDisplayName="Payslip Verification"
          input={
            <BooleanInput
              id="reports-create-payslip-verification-checkbox"
              defaultValue={resolvedPayslipVerificationDefault}
              source="payslipVerification"
              label=""
              sx={{ marginBottom: "-15px" }}
            />}
        />
      }
    </>
  );
};

export const ExpandReportButton = (props) => {
  const redirect = useRedirect();
  const { record, basePath } = props;

  return (
    allowCreationOfFollowUpReport(record) && (
      <Button
        id={`reports-list-expand-button-${record["clientRequestId"]}`}
        sx={linkButton}
        onClick={() =>
          redirect(
            basePath +
              "/create/" + record["clientRequestId"] +
              "?secondCreateReport=true"
          )
        }
      >
        Expand
      </Button>
    )
  );
}

export default IncomeDynamicFields;
